import Cookies from "js-cookie";
import {
    IItem,
    ICookieCart,
    IOrderCart,
    ICartsObject,
    IItemSimple,
    IAddressBlock,
    ISalesOrderRequest,
    IItemLine,
} from "../interfaces/cart.interfaces";
import { OverlaysService } from "./overlays.service";
import { USEREMAIL, SITEURL } from "@libTs/cms.globals";

export interface IOfferItem {
    ItemCode: string;
    ItemName: string;
    ImageURL: string;
    Quantity?: number;
    Preis?: number;
}

export class OfferService {
    private get EXPIRES(): Date {
        const now = new Date();
        now.setFullYear(now.getFullYear() + 20);
        return now;
    }
    private readonly COOKIENAME = "offer" + USEREMAIL;
    private readonly COOKIESETTINGS = { path: "/", expires: this.EXPIRES };

    private overlaysSvc: OverlaysService;

    public list: IOfferItem[] = [];

    public isLoggedIn = false;

    public openOfferList = false;

    constructor(overlaysSvc: OverlaysService, isLoggedIn: boolean = false) {
        this.overlaysSvc = overlaysSvc;
        this.isLoggedIn = isLoggedIn;

        this.initializeListFromCookie();
    }

    public isUserLoggedIn(): boolean {
        return this.isLoggedIn;
    }

    public initializeListFromCookie(): void {
        const cookie = Cookies.get(this.COOKIENAME);
        if (typeof cookie === "string" && cookie.length > 0) {
            try {
                const data = JSON.parse(cookie);
                if (Array.isArray(data)) {
                    this.list = data;
                }
            } catch (e) {
                console.error("Error parsing cart cookie", e);
            }
        }
    }

    // add to watchlist
    public add(item: IOfferItem): void {
        if (this.isUserLoggedIn()) {
            if (!this.isInList(item)) {
                this.list.push(item);
                this.saveListToCookie();
            }

            this.openOfferList = true;
        }
    }

    private isInList(item: IOfferItem): boolean {
        return this.list.some(
            (listItem) => listItem.ItemCode === item.ItemCode,
        );
    }

    private saveListToCookie(): void {
        Cookies.set(
            this.COOKIENAME,
            JSON.stringify(this.list),
            this.COOKIESETTINGS,
        );
    }

    // remove from watchlist
    public remove(item: IOfferItem): void {
        if (this.isUserLoggedIn()) {
            this.list = this.list.filter(
                (listItem) => listItem.ItemCode !== item.ItemCode,
            );
            this.saveListToCookie();
        }
    }

    // get request JSON
    public getOrderRequestObject(
        billingAddress: IAddressBlock,
        shipToCode: string,
        shipAddress: IAddressBlock,
        comments: string,
        orderRefNr?: string,
    ): Array<ISalesOrderRequest> {
        // DEBUG
        // console.log("getOrderRequestObject", {
        //     billingAddress,
        //     shipToCode,
        //     shipAddress,
        //     comments,
        // });

        const orderRequests: Array<ISalesOrderRequest> = [];

        const itemLines: IItemLine[] = [];
        let cartShippingAddress = {} as IAddressBlock;
        cartShippingAddress = Object.assign(cartShippingAddress, shipAddress);

        for (let i = 0; i < this.list.length; ++i) {
            if (this.list[i].Quantity === 0) {
                this.list.splice(i, 1);
            }

            const item = this.list[i];

            const itemLine: IItemLine = {
                ItemCode: item.ItemCode,
                Quantity: item.Quantity,
                PromoPrice: item.Preis,
            };

            itemLines.push(itemLine);
        }

        const orderRequest = {
            ItemLines: itemLines,
            Comments: comments || "",
        };

        if (
            typeof cartShippingAddress !== "undefined" &&
            (!shipToCode || shipToCode.length === 0 || shipToCode === "CSV")
        ) {
            // DEBUG
            // console.log("getOrderRequestObject if(true)", [
            //     typeof cartShippingAddress,
            //     !shipToCode,
            //     shipToCode.length === 0,
            //     shipToCode === "CSV",
            // ]);

            delete cartShippingAddress.AddressId;
            if (!cartShippingAddress.Country) {
                cartShippingAddress.Country = "CH";
            }

            if (shipToCode === "CSV") {
                cartShippingAddress.Address2 = cartShippingAddress.AddressName2; // + '\n' + cartShippingAddress.AddressName3;
                cartShippingAddress.Address3 = cartShippingAddress.AddressName3; // + ( cart.orderName.length > 0 ? ', ' + cart.orderName : '' );
            } else if (
                cartShippingAddress.Address2obj &&
                cartShippingAddress.Address3obj
            ) {
                cartShippingAddress.Address2 = `${cartShippingAddress.Address2obj.Company}
    ${cartShippingAddress.Address2obj.Department}`;
                cartShippingAddress.Address3 = `${cartShippingAddress.Address3obj.Title}
    ${cartShippingAddress.Address3obj.FirstName} ${cartShippingAddress.Address3obj.LastName}`;
                if (
                    cartShippingAddress.Address2obj &&
                    cartShippingAddress.Address2obj.County
                ) {
                    cartShippingAddress.County =
                        cartShippingAddress.Address2obj.County;
                }

                delete cartShippingAddress.Address2obj;
                delete cartShippingAddress.Address3obj;
            } else {
                cartShippingAddress.Address2 = null;
                cartShippingAddress.Address3 = null;
            }

            orderRequest.ShipAddress = cartShippingAddress;
        } else {
            // console.log("getOrderRequestObject if(false)", [
            //     orderRequest.ShipToCode,
            //     shipToCode,
            // ]);
            orderRequest.ShipToCode = shipToCode;
        }

        // billing address
        orderRequest.PayToCode = billingAddress.AddressId;

        orderRequests.push(orderRequest);

        // console.log("getOrderRequestObject orderRequests", orderRequests);
        return orderRequests;
    }
}
